import { Block } from "@components/block";
import { Button } from "@components/button";
import { Config, DoubleText, Table } from "@components/table";
import Arrow from "@assets/icons/arrow-right.svg";
import { useLead } from "@features/lead";
import { useEffect } from "react";
import { LeadOrders } from "@features/lead/api";
import { formatDate, formatTime } from "@helpers/date";
import { formatRubles, formatUsdt } from "@helpers/format";
import { EllipsisText } from "@components/ellipsis-text";
import { StatusBlock, StatusBlockType } from "@components/status-block";
import { usePagination } from "@hooks/use-pagination";
import { OrderCSVModal } from "@components/order-csv/OrderCSV";
import { useBoolState } from "@hooks/use-bool-state";

const config: Config<LeadOrders> = [
  {
    label: "ID",
    source: "order_uuid",
    renderComponent: (data) => (
      <EllipsisText text={data} startLength={10} endLength={10} copy />
    ),
  },
  {
    label: "Дата",
    source: "created_at_unix",
    renderComponent: (data) => (
      <DoubleText
        text={formatDate(new Date(data * 1000))}
        subText={formatTime(new Date(data * 1000))}
      />
    ),
  },
  {
    label: "Сумма",
    source: "order_amount",
    renderComponent: (data, item) => (
      <DoubleText
        text={formatUsdt(item.order_amount_usdt)}
        subText={formatRubles(data)}
      />
    ),
  },
  {
    label: "Доход",
    source: "earnings",
    renderComponent: (data) => formatUsdt(data),
  },
  { label: "Метод", source: "method" },
  { label: "Партнер", source: "referral_email" },
  { label: "Тип", source: "operation" },
  {
    label: "Статус",
    source: "status",
    renderComponent: (status) => {
      let text = "";
      let statusType: StatusBlockType;
      switch (status) {
        case "canceled":
          text = "Отклонена";
          statusType = StatusBlockType.Error;
          break;
        case "completed":
          text = "Успешна";
          statusType = StatusBlockType.Success;
          break;
        case "dispute_open":
          text = "Открыт спор";
          statusType = StatusBlockType.Warning;
          break;
        case "pending":
        case "processing":
        default:
          text = "Ожидает подтверждения";
          statusType = StatusBlockType.Warning;
          break;
      }
      return <StatusBlock text={text} type={statusType} />;
    },
  },
];

export const LeadDealsPage = () => {
  const { state, getLeadOrders } = useLead();
  const { page, limit, setPage, setLimit } = usePagination(100);
  const [isCSVModalOpen, showCSVModal, hideCSVModal] = useBoolState(false);

  useEffect(() => {
    getLeadOrders({ limit, page });
  }, [getLeadOrders, limit, page]);
  return (
    <>
      <Block>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <h3>История сделок</h3>
          <Button icon={Arrow} onClick={showCSVModal}>
            Создать выгрузку
          </Button>
        </div>
        <Table
          config={config}
          data={state.orders}
          loading={state.partnersLoading}
          setPage={setPage}
          setLimit={setLimit}
          limits={[100, 200, 300]}
          page={page}
          totalCount={state.ordersTotalCount}
          limit={limit}
        />
      </Block>
      {isCSVModalOpen && (
        <OrderCSVModal isModalOpen={isCSVModalOpen} hideModal={hideCSVModal} />
      )}
    </>
  );
};
